// TODO check all events and add more if there are any

/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * All event listeners
 *
 * Source: https://businesshelp.snapchat.com/s/article/pixel-direct-implementation
 * */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.snapchat?.pixel_id && !pmwDataLayer?.pixels?.snapchat?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "Snapchat")) pmw.loadSnapchatPixel()
	}
})

// PaveView event
pmw.bus.on("pmw:pixel:page-view", (payload) => {

	try {
		if (pmw.canNotFireSnapchatEvent()) return
		if (!pmw.shouldFireBrowserPixel(payload, "snapchat")) return

		// Get Snapchat data from unified payload
		const snapchatData = payload.pixels?.snapchat;
		if (!snapchatData) {
			pmw.console.warn("Snapchat event data not found in payload for page-view");
			return;
		}

		let data = {
			client_dedup_id: snapchatData.event_id,
		}

		snaptr("track", "PAGE_VIEW", data)
		// pmw.console.log("Snapchat: PAGE_VIEW event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// AddToCart event
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (pmw.canNotFireSnapchatEvent()) return
		if (!pmw.shouldFireBrowserPixel(payload, "snapchat")) return

		// Get Snapchat data from unified payload
		const snapchatData = payload.pixels?.snapchat;
		if (!snapchatData) {
			pmw.console.warn("Snapchat event data not found in payload for add_to_cart");
			return;
		}

		const product = payload.event_data?.product;
		if (!product) return;

		let data = {
			client_dedup_id: snapchatData.event_id,
			currency       : pmw.getProductCurrency(product),
			price          : product.price * product.quantity,
			number_items   : product.quantity,
			item_ids       : [pmw.getProductIdForSpecificPixel(product, "snapchat")],
		}

		snaptr("track", "ADD_CART", data)
		pmw.console.log("Snapchat Pixel: ADD_CART event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// VIEW_CONTENT event
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (pmw.canNotFireSnapchatEvent()) return
		if (!pmw.shouldFireBrowserPixel(payload, "snapchat")) return

		// Get Snapchat data from unified payload
		const snapchatData = payload.pixels?.snapchat;
		if (!snapchatData) {
			pmw.console.warn("Snapchat event data not found in payload for view_item");
			return;
		}

		const product = payload.event_data?.product;

		let data = {
			client_dedup_id: snapchatData.event_id,
		}

		if (product) {
			data.currency     = pmw.getProductCurrency(product)
			data.price        = product.price * product.quantity
			data.number_items = product.quantity
			data.item_ids     = [pmw.getProductIdForSpecificPixel(product, "snapchat")]
		}

		snaptr("track", "VIEW_CONTENT", data)
		pmw.console.log("Snapchat Pixel: VIEW_CONTENT event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// SEARCH event
pmw.bus.on("pmw:pixel:search", (payload) => {

	try {
		if (pmw.canNotFireSnapchatEvent()) return
		if (!pmw.shouldFireBrowserPixel(payload, "snapchat")) return

		// Get Snapchat data from unified payload
		const snapchatData = payload.pixels?.snapchat;
		if (!snapchatData) {
			pmw.console.warn("Snapchat event data not found in payload for search");
			return;
		}

		let data = {
			client_dedup_id: snapchatData.event_id,
			search_string  : snapchatData.custom_data.search_string,
		}

		snaptr("track", "SEARCH", data)
		pmw.console.log("Snapchat Pixel: SEARCH event sent")

	} catch (e) {
		console.error(e)
	}
})

// ADD_TO_WISHLIST event
pmw.bus.on("pmw:pixel:add-to-wishlist", (payload) => {

	try {
		if (pmw.canNotFireSnapchatEvent()) return
		if (!pmw.shouldFireBrowserPixel(payload, "snapchat")) return

		// Get Snapchat data from unified payload
		const snapchatData = payload.pixels?.snapchat;
		if (!snapchatData) {
			pmw.console.warn("Snapchat event data not found in payload for add_to_wishlist");
			return;
		}

		const product = payload.event_data?.product;
		if (!product) return;

		let data = {
			client_dedup_id: snapchatData.event_id,
			currency       : pmw.getProductCurrency(product),
			price          : product.price * product.quantity,
			number_items   : product.quantity,
			item_ids       : [pmw.getProductIdForSpecificPixel(product, "snapchat")],
		}

		snaptr("track", "ADD_TO_WISHLIST", data)
		pmw.console.log("Snapchat Pixel: ADD_TO_WISHLIST event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// LOGIN event
pmw.bus.on("pmw:pixel:login", (payload) => {

	try {
		if (pmw.canNotFireSnapchatEvent()) return
		if (!pmw.shouldFireBrowserPixel(payload, "snapchat")) return

		// Get Snapchat data from unified payload
		const snapchatData = payload.pixels?.snapchat;
		if (!snapchatData) {
			pmw.console.warn("Snapchat event data not found in payload for login");
			return;
		}

		let data = {
			client_dedup_id: snapchatData.event_id,
		}

		snaptr("track", "LOGIN", data)
		pmw.console.log("Snapchat Pixel: LOGIN event sent")

	} catch (e) {
		console.error(e)
	}
})

// START_CHECKOUT event
pmw.bus.on("pmw:pixel:begin-checkout", (payload) => {

	try {
		if (pmw.canNotFireSnapchatEvent()) return
		if (!pmw.shouldFireBrowserPixel(payload, "snapchat")) return

		// Get Snapchat data from unified payload
		const snapchatData = payload.pixels?.snapchat;
		if (!snapchatData) {
			pmw.console.warn("Snapchat event data not found in payload for begin-checkout");
			return;
		}

		let data = {
			client_dedup_id: snapchatData.event_id,
		}

		snaptr("track", "START_CHECKOUT", data)
		pmw.console.log("Snapchat Pixel: START_CHECKOUT event sent")

	} catch (e) {
		console.error(e)
	}
})


// PURCHASE event. View order received page event
// Note: Server-side transmission is handled via PHP Conversions API, this only fires the browser pixel
pmw.bus.on("pmw:pixel:purchase", () => {

	try {
		if (pmw.canNotFireSnapchatEvent()) return
		if (!pmwDataLayer.order) return

		const data = {
			// Snap deduplicates a browser event against its CAPI twin by
			// matching client_dedup_id to the CAPI event_id, so this has to
			// carry the exact same value the Snapchat CAPI purchase sends
			// (Snapchat_CAPI::build_ssp_purchase_event_data and the adapter's
			// adaptPurchase). transaction_id stays the bare order ID, because
			// that is the order number Snap reports back.
			client_dedup_id: "pmw_" + pmwDataLayer.order.id.toString(),
			currency       : pmwDataLayer.order.currency,
			price          : pmwDataLayer.order.value.marketing,
			transaction_id : pmwDataLayer.order.id,
			item_ids       : pmw.getSnapchatOrderItemIds(),
			customer_status: pmwDataLayer.order.new_customer ? "new" : "returning",
		}

		snaptr("track", "PURCHASE", data)
		pmw.console.log("Snapchat Pixel: PURCHASE event sent", data)

	} catch (e) {
		console.error(e)
	}
})
